import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { SorteioService } from '../../../../../publico/sorteios';
import { SorteioConsumidorModel } from '../../../../../shared';
import { BilheteConsumidorModel } from '../../../shared/consumidor-bilhetes.model';
import { BilheteConsumidorService } from '../../../shared/consumidor-bilhetes.service';
import { LoginService } from './../../../shared/login.service';
import { FiltroObterBilhetesSorteioConsumidor } from '../../../../../shared/model/filtro-obter-bilhetes-sorteio-consumidor';

@Component({
  selector: 'app-consumidor-visualizar-bilhetes',
  templateUrl: './consumidor-visualizar-bilhetes.component.html',
  styleUrls: ['./consumidor-visualizar-bilhetes.component.css']
})
export class ConsumidorVisualizarBilhetesComponent implements OnInit {
  public bilhetes: BilheteConsumidorModel[];
  public unsub: Subscription;
  public semRegistros = false;
  public sorteio: SorteioConsumidorModel;
  public pagina = 1;
  public tamanhoPagina = 12;
  public totalBilhetes = 0;

  @Output() public OnVoltarClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private readonly bilheteConsumidorService: BilheteConsumidorService,
    private readonly router: Router,
    private readonly sorteioService: SorteioService,
    private readonly loginService: LoginService
  ) {}

  ngOnInit() {
    this.unsub = this.bilheteConsumidorService.bilhetesChange.subscribe((data: BilheteConsumidorModel[]) => {
      this.bilhetes = data;
      this.totalBilhetes = this.bilheteConsumidorService.totalBilhetes;
      this.semRegistros = this.bilhetes.length === 0;
    });

    this.getBilhetesSorteioConsumidor();

    this.sorteio = this.bilheteConsumidorService.sorteio;
  }

  public gerarParteNomeImagem(item: BilheteConsumidorModel): string {
    return this.gerarNomeBilhete(item, 'bonus', 'gerado', 'premiado', 'gerado');
  }

  public gerarNomeOrigemBilhete(item: BilheteConsumidorModel): string {
    return this.gerarNomeBilhete(item, 'Bônus', 'Gerado', 'Premiado', 'Gerado');
  }

  private gerarNomeBilhete(
    item: BilheteConsumidorModel,
    _nomeBonus: string,
    _nomeGerado: string,
    _nomePremiadoResult: string,
    _nomeGeradoResult
  ): string {
    if (item && item.cod_tipo_origem_bilhete_consumidor === 1 && !item.seq_premio_sorteio_premiacao_consumidor) {
      return _nomeBonus;
    }

    if (item.cod_situacao_sorteio_premiacao_consumidor !== 4) {
      return _nomeGerado;
    }

    return item && item.seq_premio_sorteio_premiacao_consumidor ? _nomePremiadoResult : _nomeGeradoResult;
  }

  public voltar() {
    if (this.sorteioService.codSorteio !== 0 || this.loginService.isLogged()) {
      this.OnVoltarClicked.emit(false);
    } else {
      this.router.navigate([`/sorteios/`]);
    }
  }

  pageChange(event: number): void {
    this.pagina = event;
    this.getBilhetesSorteioConsumidor();
  }

  public getBilhetesSorteioConsumidor() {
 
    let filtro = new FiltroObterBilhetesSorteioConsumidor();
    filtro.consumidorId = this.bilheteConsumidorService.consumidor.consumidorId;
    filtro.sorteioId = this.bilheteConsumidorService.sorteio.seqSorteio;
    filtro.page = this.pagina;
    filtro.pageSize = this.tamanhoPagina;
 
    this.bilheteConsumidorService.getBilhetesSorteioConsumidor(filtro);
  }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-detalhe-sorteio/consumidor-visualizar-bilhetes/consumidor-visualizar-bilhetes/consumidor-visualizar-bilhetes.component.ts